import React from 'react';
import { CustomFullscreenBarStyled } from './styled';
import { Icon } from '@shopify/polaris';
import { ArrowLeftIcon } from '@shopify/polaris-icons';

interface IProps {
  onAction: () => void;
  children?: React.ReactNode;
  hideBackButton?: boolean;
}

const CustomFullscreenBar = (props: IProps) => {
  return (
    <CustomFullscreenBarStyled hideBackButton={props.hideBackButton}>
      <div className="fullscreen-bar__content">
        {!props.hideBackButton && (
          <div className="mr-8 cursor-pointer" onClick={props.onAction}>
            <Icon source={ArrowLeftIcon} tone="base" />
          </div>
        )}
        {props.children}
      </div>
    </CustomFullscreenBarStyled>
  );
};

export default CustomFullscreenBar;
